import React from 'react';

/**
 * Tiny "(-)" dot a user can click to restore a previously dismissed tooltip.
 * Shown only when its tooltip is currently hidden.
 *
 * Usage:
 *   <RestoreTooltipDot tooltipId="kg_upload" hiddenTooltips={hiddenTooltips} onRestore={handleRestoreTooltip} />
 */
export const RestoreTooltipDot = ({
  tooltipId,
  hiddenTooltips,
  onRestore,
  className = '',
  size = 14,
  title = 'Click to bring this hint back',
}) => {
  if (!hiddenTooltips || !hiddenTooltips[tooltipId]) return null;
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onRestore && onRestore(tooltipId); }}
      title={title}
      aria-label={`Restore hint: ${tooltipId}`}
      data-testid={`restore-tooltip-${tooltipId}`}
      className={`inline-flex items-center justify-center rounded-full border border-cyan-400/60 text-cyan-300 hover:text-cyan-200 hover:border-cyan-300 hover:bg-cyan-400/15 transition-colors leading-none cursor-pointer ${className}`}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(10, size - 4),
        fontWeight: 700,
        padding: 0,
        background: 'rgba(0,0,0,0.35)',
      }}
    >
      −
    </button>
  );
};

export default RestoreTooltipDot;
